import styled from 'styled-components';
import { COLORS, FONT_FAMILY } from '@Commons';

export const SendMoneyFeesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  min-width: 230px;

  .label {
    flex: 1;
    margin: 8% 0px 8% 6%;
    color: ${COLORS.textLightGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  .value {
    flex: 1;
    text-align: right;
    color: ${COLORS.textGrey};
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
`;
